var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommissionAgreementsSectionInnerLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.992,
    height: 91,
    viewBox: "0 0 116.992 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder-open-solid_1_",
    "data-name": "folder-open-solid (1)",
    d: "M18.017,70.959,0,101.834V45A13.012,13.012,0,0,1,13,32H36.867a13,13,0,0,1,9.2,3.8l5.383,5.383a13,13,0,0,0,9.2,3.8H84.5a13.012,13.012,0,0,1,13,13v6.5H29.25a13,13,0,0,0-11.233,6.459Zm5.606,3.27A6.506,6.506,0,0,1,29.25,71H110.5a6.513,6.513,0,0,1,5.606,9.791l-22.75,39A6.472,6.472,0,0,1,87.75,123H6.5a6.513,6.513,0,0,1-5.606-9.791l22.75-39Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionAgreementsSectionInnerLeftIcon);
export default __webpack_public_path__ + "static/media/commission-agreements-section-inner-left-icon.534241ae7d7cd4ea634456a44f552f56.svg";
export { ForwardRef as ReactComponent };